/***费用详情***/
<template>
  <div class="detailsBox" :class="{'showDetailsBox':state}">
    <div class="detailsBoxContent">
      <div class="Title">
        <h2>{{title}}</h2>
      </div>
      <div class="BoxContent">
        <slot name="content">

        </slot>
      </div>
      <div class="closeBut" @click="switchFn">
        <span>X</span>
      </div>
    </div>

    <div class="Module">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Xk-detailsBox',
    props: ['title'],
    computed: {},
    data () {
      return {
        state: false
      }
    },
    methods: {
      switchFn: function () {
        this.state = !this.state
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .detailsBox {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    z-index: -100;
    transition: 0.3s all;
    .detailsBoxContent {
      width: 80vw;
      height: auto;
      position: fixed;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -30%);
      border-radius: 0.333rem;
      z-index: 200;
      .Title {
        background-color: #fff;
        box-shadow: 0 0 10px rgba(0, 0, 0, .1);
        line-height: 3.5rem;
        height: 3.5rem;
        font-size: 1rem;
        position: relative;
        z-index: 10;
        border-radius: 0.333rem 0.333rem 0 0;
        h2 {
          text-align: center;
          color: #333333;
        }
      }
      .BoxContent {
        padding: 1rem;
        background-color: #fff;
        border-radius: 0 0 0.333rem 0.333rem;
        overflow: hidden;
        padding-bottom: 2rem;
      }
      .closeBut {
        width: 2.5rem;
        height: 2.5rem;
        line-height: 2.5rem;
        text-align: center;
        background-color: #fff;
        border-radius: 50%;
        position: absolute;
        bottom: -1rem;
        left: 50%;
        transform: translate(-50%, 10%);
        z-index: 30;
        box-shadow: 0 0 5px rgba(0, 0, 0, .1);
        span {
          position: absolute;
          left: 50%;
          top: 50%;
          color: #666;
          transform: translate(-44%, -45%);
        }
      }
    }
    .Module {
      position: fixed;
      z-index: 100;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  .showDetailsBox {
    z-index: 100;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// detailsBox.vue?a45374e4